// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --default-app-font-family: "Oxanium";
  --general-text-color: var(--gray-50);
  --general-bg: #1b182b;

  /* BRAND COLORS */
  --brand-off-black: #140d24;
  --brand-purple-light: #a34efe;
  --brand-purple-light-rgb: 163, 78, 254;
  --brand-purple-dark: #220842;
  --brand-purple-dark-1: #7830d4;
  --brand-purple: #9550ee;
  --brand-purple-rgb: 149, 80, 238;
  --brand-pink: #fc78ff;
  --brand-pink-rgb: 252, 120, 255;
  --brand-pink-700: #b722c4;
  --brand-pink-light: #ffcef6;
  --brand-pink-light-rgb: 255, 206, 246;
  --brand-pink-dark: #db17af;
  --brand-off-white: #fafcff;
  --brand-mixed-start-1: #a651ff;

  --error: var(--red-500);

  --gold-100: #ebca4e;
  --gold-200: #dda43e;
  --gold-300: #c0861e;
  --gold-500: #9d6216;

  --silver-100: #b1c0cc;
  --silver-200: #879aa8;
  --silver-300: #6f8090;
  --silver-500: #4a5762;

  --leader-gold: #f5d565;
  --leader-silver: #97a1b6;
  --leader-bronze: #a85923;

  --gray-50: #fafcff;
  --gray-50-rgb: 250, 252, 255;
  --gray-100: #e7ecf7;
  --gray-200: #bdbed7;
  --gray-300: #979ab6;
  --gray-400: #6a6d89;
  --gray-450: #6f6899;
  --gray-500: #4e516d;
  --gray-600: #383958;
  --gray-700: #2e2d4d;
  --gray-800: #22213b;
  --gray-850: rgba(19, 24, 35, 0.5);
  --gray-900: #1b182b;
  --gray-950: #140d24;

  --purple-50: #f9f5fe;
  --purple-100: #f1e8fd;
  --purple-200: #e6d7fc;
  --purple-300: #d2b6f9;
  --purple-400: #be93f6;
  --purple-500: #9550ee;
  --purple-600: #7830d4;
  --purple-700: #531b9c;
  --purple-800: #3b1072;
  --purple-900: #2c0d56;
  --purple-950: #220842;

  --blue-400: #bcf9f8;

  --black-900: rgba(0, 0, 0, 0.2);

  --plinko-tag-100: #dbb140;
  --plinko-tag-200: #e99445;
  --plinko-tag-300: #dd623b;
  --plinko-tag-400: #eb4b4b;
  --plinko-tag-500: #db3b62;
  --plinko-tag-600: #db3c9c;
  --plinko-tag-700: #b337cc;

  --green-100: rgba(105, 209, 191, 0.2);
  --green-500: #55b685;

  --green-500-rgb: 85, 182, 133;
  --red-500-rgb: 219, 59, 98;

  --red-500: #da5697;
}

.text-animated-gradient-brand-pink-purple {
  background: linear-gradient(to right, #9032f5 20%, #ff65e6 80%);
  background-size: 200% auto;
  animation: textShine 3s ease-in-out infinite alternate;
}

.text-animated-gradient-brand-pink-purple-dark {
  background: linear-gradient(to right, #4c1a81 20%, #88367a 80%);
  background-size: 200% auto;
  animation: textShine 3s ease-in-out infinite alternate;
}

.text-animated-gradient-white {
  background: linear-gradient(to right, #b1c0cc 20%, #ffffff 80%);
  background-size: 200% auto;
  animation: textShine 4s ease-in-out infinite alternate;
}

@keyframes textShine {
  0% {
    background-position: 0% 0%;
  }
  25% {
    background-position: 100% 0%;
  }
  75% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 100%;
  }
}

.bg-animated-gradient-brand-pink-purple {
  background: linear-gradient(45deg, #9032f5 20%, #ff65e6 80%);
  background-size: 200% auto;
  animation: textShine 3s ease-in-out infinite alternate;
}

.bg-animated-gradient-brand-pink-purple-light {
  background: linear-gradient(90deg, #9032f5 20%, #ffa0f0 80%);
  background-size: 200% auto;
  animation: textShine 2s ease-in-out infinite alternate;
}

.bg-animated-gradient-white {
  background: linear-gradient(90deg, #b1c0cc 20%, #ffffff 80%);
  background-size: 200% auto;
  animation: textShine 2s ease-in-out infinite alternate;
}

.bg-animated-gradient-gray-700-gray-800 {
  background: linear-gradient(90deg, #384258 20%, #2d364d 80%);
  background-size: 200% auto;
  animation: textShine 4s ease-in-out infinite alternate;
}

@keyframes rotate-gradient {
  0% {
    background-image: linear-gradient(0deg, #9032f5, #ff65e6, #1e1e1e);
  }
  0% {
    background-image: linear-gradient(18deg, #9032f5, #ff65e6, #1e1e1e);
  }
  10% {
    background-image: linear-gradient(36deg, #9032f5, #ff65e6, #1e1e1e);
  }
  15% {
    background-image: linear-gradient(54deg, #9032f5, #ff65e6, #1e1e1e);
  }
  20% {
    background-image: linear-gradient(72deg, #9032f5, #ff65e6, #1e1e1e);
  }
  25% {
    background-image: linear-gradient(90deg, #9032f5, #ff65e6, #1e1e1e);
  }
  30% {
    background-image: linear-gradient(108deg, #9032f5, #ff65e6, #1e1e1e);
  }
  35% {
    background-image: linear-gradient(126deg, #9032f5, #ff65e6, #1e1e1e);
  }
  40% {
    background-image: linear-gradient(144deg, #9032f5, #ff65e6, #1e1e1e);
  }
  45% {
    background-image: linear-gradient(162deg, #9032f5, #ff65e6, #1e1e1e);
  }
  50% {
    background-image: linear-gradient(180deg, #9032f5, #ff65e6, #1e1e1e);
  }
  55% {
    background-image: linear-gradient(198deg, #9032f5, #ff65e6, #1e1e1e);
  }
  60% {
    background-image: linear-gradient(216deg, #9032f5, #ff65e6, #1e1e1e);
  }
  65% {
    background-image: linear-gradient(234deg, #9032f5, #ff65e6, #1e1e1e);
  }
  70% {
    background-image: linear-gradient(252deg, #9032f5, #ff65e6, #1e1e1e);
  }
  75% {
    background-image: linear-gradient(270deg, #9032f5, #ff65e6, #1e1e1e);
  }
  80% {
    background-image: linear-gradient(288deg, #9032f5, #ff65e6, #1e1e1e);
  }
  85% {
    background-image: linear-gradient(306deg, #9032f5, #ff65e6, #1e1e1e);
  }
  90% {
    background-image: linear-gradient(324deg, #9032f5, #ff65e6, #1e1e1e);
  }
  95% {
    background-image: linear-gradient(342deg, #9032f5, #ff65e6, #1e1e1e);
  }
  100% {
    background-image: linear-gradient(0deg, #9032f5, #ff65e6, #1e1e1e);
  }
}
.shadow-box {
  position: relative;
  transform: translate(0);
  transform-style: preserve-3d;
}
.shadow-animated-gradient-brand-pink-purple:before {
  content: "";
  position: absolute;
  inset: 0;
  transform: translate3d(0, 0, -1px);
  background-image: conic-gradient(#9032f5, #ff65e6, #1e1e1e);
  filter: blur(15px);
  background-size: 200% auto;
  animation: rotate-gradient 3s linear infinite;
}

td .row-rounded-border {
  border-style: solid none;
}

td:first-child .row-rounded-border {
  border-left-style: solid;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

td:last-child .row-rounded-border {
  border-right-style: solid;
  border-bottom-right-radius: 6px;
  border-top-right-radius: 6px;
}

@keyframes animateScrollOdd {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes animateScrollEven {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes animateScrollAndHeight {
  from {
    transform: translateY(-100%) scaleY(10%);
  }
  to {
    transform: translateY(0) scaleY(100%);
  }
}

@keyframes animateScrolledOdd {
  from {
    background-color: var(--gray-300);
  }
  to {
    background: none;
  }
}

@keyframes animateScrolledEven {
  from {
    background-color: var(--gray-300);
  }
  to {
    background: var(--gray-700);
  }
}

.animated-table-row-odd {
  animation: animateScrollOdd 0.3s ease-in-out;
}

.animated-table-row-even {
  animation: animateScrollEven 0.3s ease-in-out;
}

.animated-first-table-row.row-odd {
  animation:
    animateScrollAndHeight 0.3s ease-in-out,
    animateScrolledOdd 1s ease-in-out;
}

.animated-first-table-row.row-even {
  animation:
    animateScrollAndHeight 0.3s ease-in-out,
    animateScrolledEven 1s ease-in-out;
}

.row-odd:nth-child(2n) {
  background: var(--gray-700);
}
.row-even:nth-child(2n + 1) {
  background: var(--gray-700);
}

@keyframes animateHeightGrow {
  from {
    max-height: 0;
  }
  to {
    max-height: 600px;
  }
}

.animated-accordion-open {
  animation: animateHeightGrow 0.5s ease-in-out;
  overflow: hidden;
}

@keyframes shrink {
  from {
    transform: scaleY(1);
  }
  to {
    transform: scaleY(0);
  }
}

@keyframes animateHeightShrink {
  from {
    max-height: 600px;
  }
  to {
    max-height: 0px;
  }
}

.animated-accordion-close {
  animation: animateHeightShrink 0.5s ease-in-out;
  overflow: hidden;
}

@keyframes moveUpDown {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0);
  }
}

.animate-move-up-down {
  animation: moveUpDown 3s ease-in-out infinite;
}

@keyframes spinY {
  from {
    transform: rotateY(0deg);
  }
  to {
    transform: rotateY(360deg);
  }
}

.animate-spin-y {
  animation: spinY 2s linear infinite;
}

@keyframes shimmer {
  0% {
    width: 0%;
    opacity: 1;
    visibility: visible;
    background-size: 0%;
  }
  75%,
  100% {
    background-size: 100%;
  }
}

.shimmer-animation {
  animation: shimmer 2s;
  background-repeat: no-repeat;
}
`, "",{"version":3,"sources":["webpack://./src/styles/theme.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,qBAAqB;;EAErB,iBAAiB;EACjB,0BAA0B;EAC1B,6BAA6B;EAC7B,sCAAsC;EACtC,4BAA4B;EAC5B,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;EAChC,qBAAqB;EACrB,+BAA+B;EAC/B,yBAAyB;EACzB,2BAA2B;EAC3B,qCAAqC;EACrC,0BAA0B;EAC1B,0BAA0B;EAC1B,8BAA8B;;EAE9B,uBAAuB;;EAEvB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;;EAExB,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;;EAEnB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB,mBAAmB;;EAEnB,+BAA+B;;EAE/B,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,qCAAqC;EACrC,oBAAoB;;EAEpB,6BAA6B;EAC7B,0BAA0B;;EAE1B,kBAAkB;AACpB;;AAEA;EACE,+DAA+D;EAC/D,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA;EACE,+DAA+D;EAC/D,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA;EACE,+DAA+D;EAC/D,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,4DAA4D;EAC5D,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA;EACE,4DAA4D;EAC5D,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA;EACE,4DAA4D;EAC5D,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA;EACE,4DAA4D;EAC5D,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA;EACE;IACE,kEAAkE;EACpE;EACA;IACE,mEAAmE;EACrE;EACA;IACE,mEAAmE;EACrE;EACA;IACE,mEAAmE;EACrE;EACA;IACE,mEAAmE;EACrE;EACA;IACE,mEAAmE;EACrE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,oEAAoE;EACtE;EACA;IACE,kEAAkE;EACpE;AACF;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,2DAA2D;EAC3D,kBAAkB;EAClB,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE;;qCAEmC;AACrC;;AAEA;EACE;;sCAEoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,mBAAmB;EACrB;EACA;;IAEE,qBAAqB;EACvB;AACF;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B","sourcesContent":[":root {\n  --default-app-font-family: \"Oxanium\";\n  --general-text-color: var(--gray-50);\n  --general-bg: #1b182b;\n\n  /* BRAND COLORS */\n  --brand-off-black: #140d24;\n  --brand-purple-light: #a34efe;\n  --brand-purple-light-rgb: 163, 78, 254;\n  --brand-purple-dark: #220842;\n  --brand-purple-dark-1: #7830d4;\n  --brand-purple: #9550ee;\n  --brand-purple-rgb: 149, 80, 238;\n  --brand-pink: #fc78ff;\n  --brand-pink-rgb: 252, 120, 255;\n  --brand-pink-700: #b722c4;\n  --brand-pink-light: #ffcef6;\n  --brand-pink-light-rgb: 255, 206, 246;\n  --brand-pink-dark: #db17af;\n  --brand-off-white: #fafcff;\n  --brand-mixed-start-1: #a651ff;\n\n  --error: var(--red-500);\n\n  --gold-100: #ebca4e;\n  --gold-200: #dda43e;\n  --gold-300: #c0861e;\n  --gold-500: #9d6216;\n\n  --silver-100: #b1c0cc;\n  --silver-200: #879aa8;\n  --silver-300: #6f8090;\n  --silver-500: #4a5762;\n\n  --leader-gold: #f5d565;\n  --leader-silver: #97a1b6;\n  --leader-bronze: #a85923;\n\n  --gray-50: #fafcff;\n  --gray-50-rgb: 250, 252, 255;\n  --gray-100: #e7ecf7;\n  --gray-200: #bdbed7;\n  --gray-300: #979ab6;\n  --gray-400: #6a6d89;\n  --gray-450: #6f6899;\n  --gray-500: #4e516d;\n  --gray-600: #383958;\n  --gray-700: #2e2d4d;\n  --gray-800: #22213b;\n  --gray-850: rgba(19, 24, 35, 0.5);\n  --gray-900: #1b182b;\n  --gray-950: #140d24;\n\n  --purple-50: #f9f5fe;\n  --purple-100: #f1e8fd;\n  --purple-200: #e6d7fc;\n  --purple-300: #d2b6f9;\n  --purple-400: #be93f6;\n  --purple-500: #9550ee;\n  --purple-600: #7830d4;\n  --purple-700: #531b9c;\n  --purple-800: #3b1072;\n  --purple-900: #2c0d56;\n  --purple-950: #220842;\n\n  --blue-400: #bcf9f8;\n\n  --black-900: rgba(0, 0, 0, 0.2);\n\n  --plinko-tag-100: #dbb140;\n  --plinko-tag-200: #e99445;\n  --plinko-tag-300: #dd623b;\n  --plinko-tag-400: #eb4b4b;\n  --plinko-tag-500: #db3b62;\n  --plinko-tag-600: #db3c9c;\n  --plinko-tag-700: #b337cc;\n\n  --green-100: rgba(105, 209, 191, 0.2);\n  --green-500: #55b685;\n\n  --green-500-rgb: 85, 182, 133;\n  --red-500-rgb: 219, 59, 98;\n\n  --red-500: #da5697;\n}\n\n.text-animated-gradient-brand-pink-purple {\n  background: linear-gradient(to right, #9032f5 20%, #ff65e6 80%);\n  background-size: 200% auto;\n  animation: textShine 3s ease-in-out infinite alternate;\n}\n\n.text-animated-gradient-brand-pink-purple-dark {\n  background: linear-gradient(to right, #4c1a81 20%, #88367a 80%);\n  background-size: 200% auto;\n  animation: textShine 3s ease-in-out infinite alternate;\n}\n\n.text-animated-gradient-white {\n  background: linear-gradient(to right, #b1c0cc 20%, #ffffff 80%);\n  background-size: 200% auto;\n  animation: textShine 4s ease-in-out infinite alternate;\n}\n\n@keyframes textShine {\n  0% {\n    background-position: 0% 0%;\n  }\n  25% {\n    background-position: 100% 0%;\n  }\n  75% {\n    background-position: 100% 100%;\n  }\n  100% {\n    background-position: 0% 100%;\n  }\n}\n\n.bg-animated-gradient-brand-pink-purple {\n  background: linear-gradient(45deg, #9032f5 20%, #ff65e6 80%);\n  background-size: 200% auto;\n  animation: textShine 3s ease-in-out infinite alternate;\n}\n\n.bg-animated-gradient-brand-pink-purple-light {\n  background: linear-gradient(90deg, #9032f5 20%, #ffa0f0 80%);\n  background-size: 200% auto;\n  animation: textShine 2s ease-in-out infinite alternate;\n}\n\n.bg-animated-gradient-white {\n  background: linear-gradient(90deg, #b1c0cc 20%, #ffffff 80%);\n  background-size: 200% auto;\n  animation: textShine 2s ease-in-out infinite alternate;\n}\n\n.bg-animated-gradient-gray-700-gray-800 {\n  background: linear-gradient(90deg, #384258 20%, #2d364d 80%);\n  background-size: 200% auto;\n  animation: textShine 4s ease-in-out infinite alternate;\n}\n\n@keyframes rotate-gradient {\n  0% {\n    background-image: linear-gradient(0deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  0% {\n    background-image: linear-gradient(18deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  10% {\n    background-image: linear-gradient(36deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  15% {\n    background-image: linear-gradient(54deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  20% {\n    background-image: linear-gradient(72deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  25% {\n    background-image: linear-gradient(90deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  30% {\n    background-image: linear-gradient(108deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  35% {\n    background-image: linear-gradient(126deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  40% {\n    background-image: linear-gradient(144deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  45% {\n    background-image: linear-gradient(162deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  50% {\n    background-image: linear-gradient(180deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  55% {\n    background-image: linear-gradient(198deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  60% {\n    background-image: linear-gradient(216deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  65% {\n    background-image: linear-gradient(234deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  70% {\n    background-image: linear-gradient(252deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  75% {\n    background-image: linear-gradient(270deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  80% {\n    background-image: linear-gradient(288deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  85% {\n    background-image: linear-gradient(306deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  90% {\n    background-image: linear-gradient(324deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  95% {\n    background-image: linear-gradient(342deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n  100% {\n    background-image: linear-gradient(0deg, #9032f5, #ff65e6, #1e1e1e);\n  }\n}\n.shadow-box {\n  position: relative;\n  transform: translate(0);\n  transform-style: preserve-3d;\n}\n.shadow-animated-gradient-brand-pink-purple:before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  transform: translate3d(0, 0, -1px);\n  background-image: conic-gradient(#9032f5, #ff65e6, #1e1e1e);\n  filter: blur(15px);\n  background-size: 200% auto;\n  animation: rotate-gradient 3s linear infinite;\n}\n\ntd .row-rounded-border {\n  border-style: solid none;\n}\n\ntd:first-child .row-rounded-border {\n  border-left-style: solid;\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\ntd:last-child .row-rounded-border {\n  border-right-style: solid;\n  border-bottom-right-radius: 6px;\n  border-top-right-radius: 6px;\n}\n\n@keyframes animateScrollOdd {\n  from {\n    transform: translateY(-100%);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n\n@keyframes animateScrollEven {\n  from {\n    transform: translateY(-100%);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n\n@keyframes animateScrollAndHeight {\n  from {\n    transform: translateY(-100%) scaleY(10%);\n  }\n  to {\n    transform: translateY(0) scaleY(100%);\n  }\n}\n\n@keyframes animateScrolledOdd {\n  from {\n    background-color: var(--gray-300);\n  }\n  to {\n    background: none;\n  }\n}\n\n@keyframes animateScrolledEven {\n  from {\n    background-color: var(--gray-300);\n  }\n  to {\n    background: var(--gray-700);\n  }\n}\n\n.animated-table-row-odd {\n  animation: animateScrollOdd 0.3s ease-in-out;\n}\n\n.animated-table-row-even {\n  animation: animateScrollEven 0.3s ease-in-out;\n}\n\n.animated-first-table-row.row-odd {\n  animation:\n    animateScrollAndHeight 0.3s ease-in-out,\n    animateScrolledOdd 1s ease-in-out;\n}\n\n.animated-first-table-row.row-even {\n  animation:\n    animateScrollAndHeight 0.3s ease-in-out,\n    animateScrolledEven 1s ease-in-out;\n}\n\n.row-odd:nth-child(2n) {\n  background: var(--gray-700);\n}\n.row-even:nth-child(2n + 1) {\n  background: var(--gray-700);\n}\n\n@keyframes animateHeightGrow {\n  from {\n    max-height: 0;\n  }\n  to {\n    max-height: 600px;\n  }\n}\n\n.animated-accordion-open {\n  animation: animateHeightGrow 0.5s ease-in-out;\n  overflow: hidden;\n}\n\n@keyframes shrink {\n  from {\n    transform: scaleY(1);\n  }\n  to {\n    transform: scaleY(0);\n  }\n}\n\n@keyframes animateHeightShrink {\n  from {\n    max-height: 600px;\n  }\n  to {\n    max-height: 0px;\n  }\n}\n\n.animated-accordion-close {\n  animation: animateHeightShrink 0.5s ease-in-out;\n  overflow: hidden;\n}\n\n@keyframes moveUpDown {\n  0% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-20px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n\n.animate-move-up-down {\n  animation: moveUpDown 3s ease-in-out infinite;\n}\n\n@keyframes spinY {\n  from {\n    transform: rotateY(0deg);\n  }\n  to {\n    transform: rotateY(360deg);\n  }\n}\n\n.animate-spin-y {\n  animation: spinY 2s linear infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    width: 0%;\n    opacity: 1;\n    visibility: visible;\n    background-size: 0%;\n  }\n  75%,\n  100% {\n    background-size: 100%;\n  }\n}\n\n.shimmer-animation {\n  animation: shimmer 2s;\n  background-repeat: no-repeat;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
